import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { LoginService } from '../../../../services/login.service';
import { Staffdropdown, Staffloginres, Stafflogin } from './../../../../models/staffLogin';
import { PlanMainService } from './../../../../plan/service/plan-main.service';
import { Router } from '../../../../../../node_modules/@angular/router';
import { DataService } from '../../../../services/data.service';
import { PlanService } from '../../../../services/plan.service';

@Component({
  selector: 'app-dialog-stafflogin',
  templateUrl: './dialog-stafflogin.component.html',
  styleUrls: ['./dialog-stafflogin.component.css']
})
export class DialogStaffloginComponent implements OnInit, OnDestroy {
  public showStaffLogin: boolean;
  public statusLogin: boolean;
  public staffId: string;
  public staffPass: string;
  public staffName: string;
  public popupState: boolean;
  public msg: string;
  public idstaffRemember: boolean;
  public menuAuthority: any;
  public staffKyoten: Staffdropdown[] = [];
  public staffKyotenItem: Staffdropdown[];
  private ngUnsubscribe = new Subject();

  @Output() onLogin = new EventEmitter<any>();

  constructor(
    private planmainService: PlanMainService,
    private loginService: LoginService,
    private router: Router,
    private _data: DataService,
    private planService: PlanService
  ) { }

  ngOnInit() {
    this.secondLoginCheck();
    this.getStaffData();
    this.keyEnter('staffId');
  }

  keyEnter(next: string) {
    // console.log('​keyEnter -> event', event.type);
    const element = <HTMLInputElement>document.getElementById(next);
    if (this.staffId && this.staffPass) {
      if (element) {
        element.focus();
      }
      this.secondLogin();
    } else {
      setTimeout(_ => {
        if (element) {
          element.focus();
        }
      }, 200);
    }
  }

  // passChange(event?) {
  //   const value = (<HTMLInputElement>document.getElementById('pass')).value;
  //   // const id = event.target.id;
  //   const type = (<HTMLInputElement>document.getElementById('pass')).type;

  //   console.log(type, '​passChange -> ', value);

  //   let showtext = '';
  //   this.staffPass = value;
  //   if (this.staffPass) {
  //     for (let i = 0; i < value.length; i++) {
  //       showtext += String.fromCharCode(8226);
  //     }
  //   }

  //   if (event && event.type === 'focus' && type !== 'password') {
  //     (<HTMLInputElement>document.getElementById('pass')).type = 'password';
  //     (<HTMLInputElement>document.getElementById('pass')).value = this.staffPass;
  //   } else if (type === 'password') {
  //     (<HTMLInputElement>document.getElementById('pass')).type = 'tel';
  //     (<HTMLInputElement>document.getElementById('pass')).value = showtext;
  //   }
  // }

  secondLogin() {
    // this.passChange();
    const staffLogin = { staffCd: this.staffId, pass: this.staffPass };
    // console.log('​staffLogin ->', staffLogin);
    this.planmainService
      .loginDialogModel(staffLogin)
      .takeUntil(this.ngUnsubscribe)
      .subscribe(
        async (res: Staffloginres) => {   //[2021-09-08 kyuwa #7394]upd:新車デリ考慮
          this.statusLogin = res.results;
          if (this.statusLogin === true) {
            if (this.idstaffRemember) {
              this._data.idstaffRemember = this.staffId;
            } else {
              this._data.idstaffRemember = null;
            }
            this._data.staffData = { ...res, ...this.staffKyotenItem[0] }; // this.staffKyotenItem
            this._data.saveData('kyotenCd', this.staffKyotenItem[0].kyotenCd);
            this._data.saveData('staffCd', this.staffKyotenItem[0].staffCd);
            this._data.kyotenCdUpdate.next(true);
            const isPage = this.planmainService.isPageLogin.getValue();

            //▽[2021-09-08 kyuwa #7394]add:新車デリ考慮
            // 新車デリバリー契約かどうか保持する
            // TODO: staff/authのAPIに新車デリバリーかどうか持たせてhomeを呼ばないように
            this.planService._isNewCarDeliveryUser = await this.planService.isNewCarDeliveryUser();
            //△[2021-09-08 kyuwa #7394]add:新車デリ考慮

            setTimeout(_ => {
              this.staffName = res.staffNm;
              // this.onLogin.emit(true);
              this.onLogin.emit({
                kyotenNm: this.staffKyotenItem[0].kyotenNm,
                ...res
              });

              if (isPage === 'plansearch' || isPage === 'newcar' || isPage === 'stock') {
                this.planmainService.staffDialogCallback.next(true);
              } else if (isPage === 'usedcar') {
                this.planmainService.staffDialogCallback.next(true);
                this.router.navigate(['/planmain']);
              } else {
                this.planmainService.staffDialogCallback.next(null);
                if (isPage === 'osusume') {
                  this.router.navigate(['/osusume']);
                }
              }
            }, 200);
          } else {
            this.popupState = false;
          }
          // console.log('​secondLogin ->');
          // this.loginService.isStaffAuthenticated('dialogstaff');
        },
        err => {
          if (err === 404) {
            this.popupState = false;
          } else if (err === 400) {
            this.popupState = false;
            (<HTMLInputElement>document.getElementById('pass')).focus();
          }
        }
        );
      setTimeout(() => {
        // console.log('​secondLogin -> ');
        if (this._data.staffData) {
          this.loginService.isStaffAuthenticated('dialogstaff');
        }
      }, 1000);
    }
  

  closePopup() {
    this.popupState = true;
  }

  secondLoginCheck() {
    const staffRemember = this._data.idstaffRemember;
    if (staffRemember != null) {
      this.staffId = staffRemember;
      this.idstaffRemember = true;
    } else {
      this.staffId = '';
      this.staffPass = '';
    }
    if (this._data.staffData && this._data.staffData.results === true) {
      this.staffName = this._data.staffData.staffNm;
      this.statusLogin = this._data.staffData.results;
    }
  }

  getStaffData() {
    this.planmainService
      .getStaffname()
      .takeUntil(this.ngUnsubscribe)
      .subscribe(res => {
        this.staffKyoten = res;
        if (this.staffId) {
          this.selectStaffname();
        }
        //  console.log('getStaffData()', res);
      });
  }

  selectStaffname() {
    this.staffKyotenItem = this.staffKyoten.filter(
      val => val.staffCd === this.staffId
    );
    // console.log(this.staffKyotenItem);
    // this._data.saveData('kyotenCd', this.staffKyotenItem[0].kyotenCd);
    // this._data.saveData('staffCd', this.staffKyotenItem[0].staffCd);
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.planmainService.isPageLogin.next(null);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/header/dialog-stafflogin/dialog-stafflogin.component.ts